import { CLOUDINARY_NAME } from '../../constants/images/cloudinary'
import { RATING_REVIEW_IMAGES_PARAMS } from '../../constants/images/sizesAndQuality'
import cloudinary  from 'cloudinary-core'

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME
})

export const handleHeicImageType = (url, jpg_url, cloudinary_public_id) => {
  const imageType = url?.split(".").pop()
  if (imageType == "heic" || "heif") {
    return cl.url(jpg_url, RATING_REVIEW_IMAGES_PARAMS)
  } else {
    return cl.url(url, RATING_REVIEW_IMAGES_PARAMS)
  }
}